<div class="float-left">
  <form [formGroup]="filterForm" fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="2px">
    <mat-form-field appearance="outline">
      <mat-label>Fields</mat-label>
      <mat-select formControlName="field">
        <mat-option *ngFor="let factory of filterFactories" [value]="factory">
          {{factory.field!.label}}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>Operator</mat-label>
      <mat-select formControlName="operator">
        <mat-option *ngFor="let operator of operators" [value]="operator">
          {{operator.label}}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline" *ngIf="criterias">
      <mat-label>Criteria</mat-label>
      <mat-select formControlName="criteria" multiple>
        <mat-option *ngFor="let criteria of criterias" [value]="criteria.value">
          {{criteria.label}}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline" *ngIf="!criterias">
      <mat-label>Criteria</mat-label>
      <input matInput type="text" formControlName="criteria" (keyup.enter)="createFilter()">
    </mat-form-field>
  </form>
</div>
<div class="mt-1 float-right">
  <button mat-stroked-button [disabled]="!filterForm.valid" (click)="createFilter()">Apply</button>
</div>

